module.exports = __webpack_public_path__ + "static/a-titan-raises-the-bar-cta-banner-1920x515-4f79729b9d7aa4fd9fc0baaffb4957a7.jpg";